(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
(function(){
  // static JS only (no Liquid here)
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[data-scroll="true"]');
    if(!a) return;

    var sel = a.getAttribute('data-target');
    if(!sel) return;

    var off = parseInt(a.getAttribute('data-offset') || '0', 10);
    var el  = document.querySelector(sel);
    if(!el) return;

    e.preventDefault();
    var top = el.getBoundingClientRect().top + window.pageYOffset - off;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }, { passive: false });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-faq-accordion"] && !Shopify.designMode) return;
  try {
    
/* NS FAQ — static accordion (no Liquid in this block) */
(function(){
  document.querySelectorAll('.ns-faq').forEach(function(root){
    var allowMulti = (root.dataset.allowMulti === 'true');
    var startFirst = (root.dataset.startFirstOpen === 'true');
    var items = root.querySelectorAll('.ns-item');

    items.forEach(function(item, idx){
      var btn = item.querySelector('.ns-q');
      var ans = item.querySelector('.ns-a');
      var inner = item.querySelector('.ns-a-inner');

      function open(){
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded','true');
        ans.style.blockSize = inner.scrollHeight + 'px';
      }
      function close(){
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded','false');
        ans.style.blockSize = 0;
      }

      btn.addEventListener('click', function(){
        var isOpen = item.classList.contains('is-open');
        if(!allowMulti){
          items.forEach(function(i){
            if(i!==item){
              i.classList.remove('is-open');
              var a=i.querySelector('.ns-a'); var b=i.querySelector('.ns-q');
              if(a) a.style.blockSize=0; if(b) b.setAttribute('aria-expanded','false');
            }
          });
        }
        isOpen ? close() : open();
      });

      if(startFirst && idx===0){ open(); }

      var rid;
      window.addEventListener('resize', function(){
        cancelAnimationFrame(rid);
        rid = requestAnimationFrame(function(){
          if(item.classList.contains('is-open')){
            ans.style.blockSize = inner.scrollHeight + 'px';
          }
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
